import React from "react";
import "./MiddleContent.css";
import socrates from "./../../images/socrates.svg";
const MiddleContent = () => {
  const yearsOfExperience = Math.floor(
    (Date.now() - new Date("2012-09-01").getTime()) /
      (1000 * 60 * 60 * 24 * 365.25)
  );
  return (
    <div className="middleContent">
      <div className="containerContent">
        <div className="content">
          <h1>What do I do?</h1>
          <p>
            I have {yearsOfExperience}+ years of experience writing and shipping production-grade
            server-side systems. My primary language is{" "}
            <span className="redHighLight">TypeScript</span> /{" "}
            <span className="redHighLight">JavaScript</span>. Node.js is home,
            but I also write production{" "}
            <span className="redHighLight">Golang</span> and{" "}
            <span className="redHighLight">PHP</span> (Symfony). I spend a lot
            of time on the backend: REST APIs, microservices, event-driven
            architectures, database design, and the infrastructure that holds it
            all together on AWS.
          </p>
          <p>
            I have built and shipped platforms across domains ranging from
            quantum computing and telecom product catalogs to AI-powered site
            builders serving tens of thousands of daily users. I still write the code. I am
            not the person who draws boxes on a whiteboard and delegates the
            hard parts. The hard parts are the interesting parts.
          </p>
          <p>
            Over the years I have also led teams, established deployment
            standards, driven CI/CD automation, and mentored engineers. Those
            things happen alongside the work, not instead of it.
          </p>
          <p>
            In my free time I love tinkering in{" "}
            <span className="redHighLight">Rust</span>, and lately building
            agentic LLM tooling. The combination of low-level systems thinking
            and high-level AI orchestration is genuinely the most interesting
            space to be in right now. I am unabashedly nerdy but thankfully not
            needy 🤣
          </p>
          <p>
            In case you want to skip the narrative, Please feel free to checkout
            my &nbsp;
            <a
              href="https://github.com/nickx720"
              target="_blank"
              rel="noreferrer"
            >
              Github
            </a> &amp;&nbsp;
            <a
              href="https://gitlab.com/nick_thomas"
              target="_blank"
              rel="noreferrer"
            >
              GitLab
            </a>
          </p>
          <h2>Values I would add in a Team</h2>
          <ul>
            <li>
              Someone who raises the engineering bar, not just by writing good
              code, but by building the standards and culture that make everyone
              better.
            </li>
            <li>
              Someone who leads from the front on hard problems and isn't afraid
              of brownfield systems or ambiguous requirements.
            </li>
            <li>Not afraid to pick up a new tech stack.</li>
            <li>
              Excellent recommendations in which TV shows/movies to watch and
              books to read!
            </li>
          </ul>
        </div>
      </div>
      <div className="socratesContent">
        <div className="leftContent">
          <div className="quoteBlock">
            <p className="quoteContent">
              "True knowledge exists in knowing that you know nothing."
            </p>
            <p className="referenceQuote">- Socrates</p>
            <img src={socrates} alt="aristotle" className="mobSocrates"></img>
          </div>
          <p>
            Socrates's words hold true for every job in the modern world, but in
            regards to software engineering, it holds the most weight. We are
            part of the most exciting times especially with regards to tech. It
            took me two days to get this site up and running, what would take a
            whole team an entire week a few years ago. I want to be part of a
            project or company who appreciates the fact that software has eaten
            the world.
          </p>
          <p>
            We are part of something bigger than ourselves and on this long
            journey that we call life, we should ensure that our actions stay
            coherent with who we are, and who we want to be. The only constant
            is change, and a person must grow and adapt to survive in this
            hyper-competitive world.
          </p>
        </div>
        <div className="rightContent">
          <img src={socrates} alt="aristotle" className="socrates"></img>
        </div>
      </div>
    </div>
  );
};

export default MiddleContent;
